import React from 'react'

export const HomeEnterprisePageContext = React.createContext({})

export const useHomeEnterpriseContext = () => {
  const { showAddToPlaylist } =
    React.useContext(HomeEnterprisePageContext)

  return {
    showAddToPlaylist
  }
}

export const HomeEnterprisePageProvider = ({ children, value }) => {
  return (
    <HomeEnterprisePageContext.Provider value={value}>
      {children}
    </HomeEnterprisePageContext.Provider>
  )
}
